import { render, staticRenderFns } from "./Footer-Wx.vue?vue&type=template&id=4c0fa918&scoped=true&"
import script from "./Footer-Wx.vue?vue&type=script&lang=js&"
export * from "./Footer-Wx.vue?vue&type=script&lang=js&"
import style0 from "./Footer-Wx.vue?vue&type=style&index=0&id=4c0fa918&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c0fa918",
  null
  
)

export default component.exports